<template>
  <v-container id="delivery-paylog">
    <div>
      <v-row>
        <v-col cols="12">
          <span class="font-weight-black">[결제 정보]</span>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <span class="font-weight-black">배송 요금</span>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <span>
            {{deliveryFee.toLocaleString()}}
          </span>
          <!-- 수정이 필요한 부분이나 시간이 없어 임시로 변경버튼 주석처리 -->
           <c-btn color="grey" icon iconName="create" iconSize="16" @click="updateFeeDialog=true;updateFee=deliveryFee "></c-btn>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <span class="font-weight-black">결제 상태</span>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          {{ payState }}
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <span class="font-weight-black">실 결제 요금</span>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          {{ realFee.toLocaleString() }}
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <span class="font-weight-black">결제 수단</span>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          {{payMethod}}
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row>
        <v-col cols="12">
          <span class="font-weight-black">[결제 내역]</span>
        </v-col>
        <v-col cols="12">
          <c-table :headers="headers" :items="payLogList" hide-default-footer>
            <template #expectedFee="{item}">
              {{$func.numberFormatter(item.expectedFee)}}
            </template>
            <template #realFee="{item}">
              {{$func.numberFormatter(item.realFee)}}
            </template>
            <template #outstandingBalance="{item}">
              {{$func.numberFormatter(item.outstandingBalance)}}
            </template>
            <template #created="{item}">
              {{$func.dateTimeToString(item.created)}}
            </template>
          </c-table>
        </v-col>
      </v-row>
    </div>

    <v-dialog v-model="updateFeeDialog" persistent max-width="410px">
      <v-card class="white">
        <v-card-title>
          <span>배송 요금 수정</span>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pt-5">
          <v-row align="center">
            <v-col cols="4">
              배송 요금
            </v-col>
            <v-col cols="8">
              <v-text-field v-model="updateFee"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <div class="justify-center d-flex py-4">
          <c-btn class="mx-2" color="blue" outlined @click="onUpdateDeliveryFee">수정</c-btn>
          <c-btn class="mx-2" color="gray" outlined @click="updateFeeDialog = false">취소</c-btn>
        </div>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: "DeliveryPayLog",
  props:{
    payLogList: {
      type: Object,
      default:[]
    },
    deliveryFee:{
      type: Number,
      default:0
    },
    realFee:{
      type: Number,
      default: 0.0
    },
    payMethod: {
      type: String,
      default: '-'
    },
    deliveryId:{
      type: String,
      default:''
    }
  },
  data() {
    return {
      headers:[
        {text:'종류', value:'payMethod', sortable:false, align:'center'},
        {text:'시간', value:'created', sortable:false, align:'center'},
        {text:'배송요금', value:'expectedFee', sortable:false, align:'center'},
        {text:'실 결제요금', value:'realFee', sortable:false, align:'center'},
        {text:'미수금', value:'outstandingBalance', sortable:false, align:'center'},
      ],
      items:[],
      updateFeeDialog:false,
      updateFee: 0,
      totalPaidFee:0.0,
      payState: '-',
    }
  },
  watch:{
    payLogList(logList) {
      if(logList.length > 0) {
        this.items = logList;
        this.payState = logList[0].payState;
      }
    },
  },
  methods:{
    onUpdateDeliveryFee() {
      this.updateFeeDialog = false;
      const request = {
        id:this.deliveryId,
        updatedFee: this.updateFee,
        totalPaidFee: this.realFee,
      }
      this.$emit('reqUpdateDeliveryFee', request);
    }
  }
}
</script>

<style scoped>

</style>